import React from 'react';
import { PRODUCT_NAME } from '../../lib/tenant';

type Props = {
  /** Compact mark only (nav), or include wordmark */
  showWordmark?: boolean;
  /** Smaller for dense headers; lg for auth screens */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Light text on dark nav (default) or dark on light */
  variant?: 'onDark' | 'onLight';
};

/**
 * Brand mark — fixed emerald accent (not theme-tinted).
 * Wordmark always reads "Edge Finance Pro".
 */
export function EdgeFinancesLogo({
  showWordmark = true,
  size = 'md',
  className = '',
  variant = 'onDark',
}: Props) {
  const box =
    size === 'sm'
      ? 'h-8 w-8 min-h-8 min-w-8'
      : size === 'lg'
        ? 'h-[4.5rem] w-[4.5rem] min-h-[4.5rem] min-w-[4.5rem]'
        : 'h-9 w-9 min-h-9 min-w-9';
  const wordLight = variant === 'onDark';
  const logo512 = `${process.env.PUBLIC_URL || ''}/splash-logo-512.png`;
  const logoHd = `${process.env.PUBLIC_URL || ''}/splash-logo.png`;

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src={logo512}
        srcSet={`${logo512} 1x, ${logoHd} 2x`}
        alt={showWordmark ? '' : PRODUCT_NAME}
        aria-hidden={showWordmark ? true : undefined}
        className={`${box} shrink-0 rounded-[22%] object-cover shadow-sm ring-1 ring-black/10`}
        decoding="async"
      />
      {showWordmark && (
        <span
          className={`font-display text-lg font-semibold tracking-tight sm:text-xl ${
            wordLight ? 'text-white' : 'text-slate-900'
          }`}
        >
          Edge Finance{' '}
          <span className={wordLight ? 'text-emerald-400' : 'text-emerald-700'}>Pro</span>
        </span>
      )}
    </div>
  );
}
